module.exports = __webpack_public_path__ + "static/media/de.303bc4e2.svg";